import { render, staticRenderFns } from "./SelectPercentage.vue?vue&type=template&id=db16a168&"
import script from "./SelectPercentage.vue?vue&type=script&lang=js&"
export * from "./SelectPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports